import httpService from '@/utils/request'
import { contextPath } from '@/config/'

export const searchTagsListApi = (params) => {
  return httpService({
    url: contextPath + '/spider/tag/item',
    method: 'get',
    params
  })
}

export const createTagApi = (data) => {
  return httpService({
    url: contextPath + '/spider/tag/item',
    method: 'post',
    data
  })
}

export const updateTagApi = (data) => {
  return httpService({
    url: contextPath + '/spider/tag/item',
    method: 'put',
    data
  })
}

export const deleteTagApi = (id) => {
  return httpService({
    url: contextPath + '/spider/tag/item/' + id,
    method: 'delete'
  })
}
